import apiFetch from '../apiFetch'

export default function (CommentId, token) {
  return apiFetch({ endPoint: `comment/${CommentId}`, method: 'DELETE', body: null, token: token })
}
